<label class="switch-button" [ngStyle]="switchButtonDynamicStyles">
    <app-tooltip [dynamic]="false" [disable]="!hasTooltip" [message]="switchButtonConfiguration.tooltipText">
        <div class="switch-tracker-wrapper"
             [ngClass]="{'disabled': switchButtonModel.disabled}"
             [attr.data-cy]="switchTrackerDataCy('button')">
            <input [(ngModel)]="switchButtonModel.checked"
                   (change)="toggle($event)"
                   [disabled]="switchButtonModel.disabled"
                   type="checkbox">
            <div class="track"
                 [attr.data-cy]="switchTrackerDataCy('button-track')"
                 [ngClass]="{'track-disabled': switchButtonModel.disabled}"></div>
        </div>
    </app-tooltip>
</label>
<span class="switch-button-label"
      [ngStyle]="{'min-width.px': switchButtonConfiguration.minWidth}"
      [ngClass]="{'track-disabled': switchButtonModel.disabled, 'bold': $safeNavigationMigration(switchButtonConfiguration?.labelBold)}"
      [attr.data-cy]="switchTrackerDataCy('label')">{{switchButtonConfiguration.label}}</span>
